import React from 'react';
import { ListGroup, Badge } from 'react-bootstrap';
import { BookmarkViewModel } from '../apiClient';

interface BookmarkResultsProps {
    bookmarks: BookmarkViewModel[];
}

export const BookmarkResults: React.FC<BookmarkResultsProps> = ({ bookmarks }) => {
    return (
        <ListGroup variant="flush">
            {bookmarks.map((bookmark) => (
                <ListGroup.Item key={bookmark.id} className="d-flex justify-content-between align-items-start">
                    <div className="ms-2 me-auto">
                        <div className="fw-bold">
                            <a href={bookmark.url!} target="_blank" rel="noopener noreferrer">
                                {bookmark.name || bookmark.url}
                            </a>
                        </div>
                        <small className="text-muted">{bookmark.url}</small>
                        {bookmark.categoryName && (
                            <Badge bg="secondary" className="ms-2">
                                {bookmark.categoryName}
                            </Badge>
                        )}
                    </div>
                </ListGroup.Item>
            ))}
        </ListGroup>
    );
};
